import React from "react";
import { SCORE_DOMAINS } from "./leaderboardHelpers";

export default function LeaderboardScoreMix({ row, compact = false }) {
  const parts = SCORE_DOMAINS.map((domain) => ({
    ...domain,
    value: Number(row?.[domain.key]) || 0,
  })).filter((d) => d.value > 0);

  const total = parts.reduce((sum, p) => sum + p.value, 0) || 1;

  if (!parts.length) {
    return <p className="alb-mix-empty">No score activity in this period.</p>;
  }

  return (
    <div className={`alb-mix${compact ? " alb-mix-compact" : ""}`}>
      <div className="alb-mix-bar" role="img" aria-label="Score domain mix">
        {parts.map((part) => (
          <span
            key={part.key}
            className="alb-mix-seg"
            style={{
              width: `${(part.value / total) * 100}%`,
              background: part.color,
            }}
            title={`${part.label}: ${part.value.toFixed(1)}`}
          />
        ))}
      </div>
      <div className="alb-mix-legend">
        {parts.map((part) => (
          <span key={part.key} className="alb-mix-chip">
            <i style={{ background: part.color }} aria-hidden />
            <em>{part.label}</em>
            <strong className="tabular-nums">{part.value.toFixed(1)}</strong>
          </span>
        ))}
      </div>
    </div>
  );
}
